import { Routes as ReactRouterRoutes } from 'react-router-dom';
import { withSentryReactRouterV6Routing } from '@sentry/react';

const Routes = withSentryReactRouterV6Routing(ReactRouterRoutes);

export default Routes;
